/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const revokeInvitationDataSchema = z.object({
	invitationId: z.string(),
})

export type RevokeInvitationDataSchema = z.infer<typeof revokeInvitationDataSchema>
